export interface FacebookCaptionSegment {
  isHashtag: boolean;
  text: string;
}

export const FACEBOOK_CAPTION_HASHTAG_PATTERN = /(#[\p{L}\p{N}_]+)/u;

export const FACEBOOK_ACTION_ICONS = ['icon-thumbs-up', 'icon-comment', 'icon-share-external', 'icon-bookmark'] as const;
export const FACEBOOK_REACTION_LIKE_ICON_PATH = 'socialmedia/reaction-like-icon-facebook.svg';
export const FACEBOOK_REACTION_LOVE_ICON_PATH = 'socialmedia/reaction-love-icon-facebook.svg';
